import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

export function Logo() {
  return (
    <Link to="/" className="flex items-center gap-2">
      <Zap className="w-8 h-8 text-vincer-500" />
      <span className="text-xl font-bold">Vincer</span>
    </Link>
  );
}